module.exports = __webpack_public_path__ + "img/phone.b0ca7f96.png";